import { Col, Image, Row, Space, Upload } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import Button from 'components/Button';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd/lib';
import { HocChangePagination } from 'utils/HocChangePagination';
import { EditIcon, EyeIcon } from 'assets/svg';
import { DownloadOutlined } from '@ant-design/icons';
import { IProduct } from 'interface/product.interface';
import { useMutation, useQuery } from 'react-query';
import CartApi from 'apis/CartApi';
import handleError401 from 'utils/handleError401';
import { useState } from 'react';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';

interface IProps {
  id: string;
}

export default function CartProduct(props: IProps): JSX.Element {
  const { id } = props;

  const history = useHistory();

  const [products, setProduct] = useState<IProduct[]>([]);
  const [total, setTotal] = useState<number>(0);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const pagination = { page: page, page_size: page_size };

  useQuery(
    ['getCartProduct', pagination],
    () => CartApi.getCartProduct(id, pagination),
    {
      onSuccess: (response) => {
        setProduct(response.data);
        setTotal(response.total);
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const { isLoading: getAllProductLoading, mutate: getAllProduct } =
    useMutation(
      ['getAllProduct'],
      () => CartApi.getCartProduct(id, { page: 1, page_size: total }),
      {
        onSuccess: (response) => {
          generateExcel(response.data);
        },
        onError: (error: any) => {
          console.log(error);
        },
      }
    );

  type FixedType = 'left' | 'right' | boolean;
  const columns: ColumnsType<IProduct> = [
    {
      title: 'STT',
      dataIndex: 'ma_mau',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 177,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (record: any) => {
        return (
          <Image
            className="border border-solid border-neutral-90 rounded-lg"
            src={record}
            width={50}
            height={50}
          />
        );
      },
      width: 100,
    },
    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 261,
    },
    {
      title: 'Ni',
      dataIndex: 'ni_sanpham',
      width: 261,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'nganh_hang',
    },
    {
      title: 'Dòng hàng',
      dataIndex: 'dong_hang',
      width: 148,
    },
    {
      title: 'X-man',
      dataIndex: 'xman',
      width: 148,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      width: 148,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      width: 148,
      align: 'right',
    },
    {
      title: 'Tổng SL tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 112,
      align: 'right',
    },
    {
      title: 'Tổng giá trị tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 112,
      align: 'right',
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'gia_tb',
      width: 112,
      align: 'right',
    },
    {
      title: 'Chi nhánh',
      dataIndex: 'chi_nhanh',
      width: 112,
      render: (record: any) => record.map((item: any) => item.code).join(','),
    },
    {
      title: 'Cửa hàng',
      dataIndex: 'cua_hang',
      width: 112,
      render: (record: any) => record.map((item: any) => item.code).join(','),
    },
    {
      title: 'Số lượng phân bổ',
      dataIndex: 'so_luong_phan_bo',
      width: 112,
      align: 'right',
    },
    {
      title: 'Vốn tồn phân bổ',
      dataIndex: 'von_ton_phan_bo',
      width: 112,
      align: 'right',
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'pro_code',
      width: 112,
    },
    {
      title: 'Mã danh mục',
      dataIndex: 'pof_code',
      width: 112,
    },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
    {
      title: '',
      fixed: 'right' as FixedType,
      width: 100,
      render: (record: any) => (
        <div className="flex justify-around">
          <button onClick={() => history.push(`/product/${record.pro_code}`)}>
            <EyeIcon />
          </button>
          {/* <button>
            <EditIcon />
          </button> */}
        </div>
      ),
    },
  ];

  function generateExcel(products: any) {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      return column.title;
    });
    data.push(headerRow);
    products.forEach((product: any) => {
      const rowData = columns.map((column) => {
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `danh_sach_san_pham.xlsx`);
  }

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            className="mb-3"
          >
            <Col span={12}>
              <div className="text-xl font-bold">
                Danh sách sản phẩm thuộc giỏ hàng
              </div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={getAllProduct}
                    disabled={getAllProductLoading}
                  >
                    <DownloadOutlined />
                    Tải file excel
                  </Button>
                </Space>
              </Row>
            </Col>
          </Row>
          <Table
            loading={getAllProductLoading}
            rowKey={(record) => record.ma_mau}
            className="customTable"
            size="small"
            columns={columns}
            dataSource={products}
            scroll={{ x: 970 }}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
          />
        </Content>
      </div>
    </>
  );
}
